import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GooglePlacesService {
  constructor() {}

  private GetAddressComponent(place, componentTemplate) {
    let result;

    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (componentTemplate[addressType]) {
        result = place.address_components[i][componentTemplate[addressType]];
        return result;
      }
    }
    return;
  }

  public GetStreetNumber(place) {
    const COMPONENT_TEMPLATE = { street_number: 'short_name' },
      streetNumber = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return streetNumber;
  }

  public GetStreet(place) {
    const COMPONENT_TEMPLATE = { route: 'long_name' },
      street = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return street;
  }

  public GetCity(place) {
    const COMPONENT_TEMPLATE = { locality: 'long_name' },
      city = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return city;
  }

  public GetProvince(place) {
    const COMPONENT_TEMPLATE = { administrative_area_level_1: 'long_name' },
      state = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return state;
  }

  public GetSuburb(place) {
    const COMPONENT_TEMPLATE = { sublocality_level_1: 'long_name' },
      suburb = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    if (suburb) {
      return suburb;
    } else {
      return this.GetSuburbLevel2(place);
    }
  }

  public GetSuburbLevel2(place) {
    const COMPONENT_TEMPLATE = { sublocality_level_1: 'long_name' },
      suburbLevel2 = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return suburbLevel2;
  }

  public GetPostCode(place) {
    const COMPONENT_TEMPLATE = { postal_code: 'long_name' },
      postCode = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return postCode;
  }

  public GetCountryShort(place) {
    const COMPONENT_TEMPLATE = { country: 'short_name' },
      countryShort = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return countryShort;
  }

  public GetCountry(place) {
    const COMPONENT_TEMPLATE = { country: 'long_name' },
      country = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return country;
  }
  public GetPhone(place) {
    const COMPONENT_TEMPLATE = {
        formatted_phone_number: 'formatted_phone_number',
      },
      phone = this.GetAddressComponent(place, COMPONENT_TEMPLATE);
    return phone;
  }
}
